import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { flowType } from '../../../utility/userInfo';
import { getObjectValue } from '@utility/utills'
import { LABEL } from '../../../veriables';
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import {ReactComponent as SearchIcon} from '@assets/images/Searchfield.svg';
import 'react-simple-keyboard/build/css/index.css';
import cn from 'classnames';
import Styles from './search.module.scss';
import { TouchableDiv } from '@components/common/Touchable'

const Search = (props) => {
  // Props Destructuring
  const {
    onChange,
    maxLength,
    autoKeyboard = false,
    getKeyboardStatus = false,
    customClass1,
    customClass2,
    placeholderName,
    serverAppTheme,
  } = props

  // State Management
  const [isSearch, setIsSearch] = useState(() => autoKeyboard);
  const ref = useRef(null);
  const keyboard = useRef(null);
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const [searchString, setSearchString] = useState('');
  const [inputName, setInputName] = useState('search');
  const [inputs, setInputs] = useState({});
  const [typed, setTyped] = useState({});
  const isServerApp = flowType() === 'serverApp';
  const isCallCenter = getObjectValue(() => isServerApp && [2].includes(props.deviceInfo.deviceGroup.startMode), false);

  // React Hooks 
  
  useEffect(() => {
    if (isSearch && searchString && keyboard.current) {
      keyboard.current.input.default = searchString;
    }
    if (isSearch && !searchString && keyboard.current) {
      keyboard.current.input.default = '';
    }
    if (getKeyboardStatus) {
      getKeyboardStatus(isSearch);
    }
  }, [isSearch, searchString]);

  // Methods
  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const handleBlur = () => {
    const element = document.querySelector('#search');
    element.blur();
  };

  const closeKeyboard = () => {
    setIsSearch(false);
  };
  const onClickBtn = (e) => {
    const value = e === '{bksp}' ? { ...inputs, [inputName]: inputs[inputName]?.slice(0, -1) } : { ...inputs, [inputName]: inputs[inputName] ? inputs[inputName].concat(e) : ''.concat(e) };
    if (!isCallCenter) {
      setInputs({
        ...inputs,
        [inputName]: value[inputName]
      });
      onChange(value[inputName]);
      setSearchString(value[inputName]);
    } else {
      setInputs({
        [inputName]: e
      });
      onChange(e);
      setSearchString(e);
    }
  };
  
  const handleInputChange = (event) => {
    onClickBtn(event);
  };

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: ''
    });
    setTyped({
      ...typed,
      [data]: ''
    });
  };

  // HTML CSS CODE
  return (
    <div
      ref={ref}
      className={cn("h-100 position-relative", customClass1)}
    >
       <div
        className={cn("position-absolute fs-16  row mx-0 align-items-center justify-content-end pr-2",)}
        style={{
          left: '2%',
          top: '50%',
          width:  '5%' ,
          transform: 'translateY(-50%)',
        }}
      >
        <SearchIcon role="presentation" height={20} width={20} onClick={() => setIsSearch(true)} fill={serverAppTheme?.iconcolor}  aria-hidden="true" />
      </div>   
      <input
        id="search"
        type="text"
        className={cn('h-100 px-5 w-100 fs_16', isCallCenter && 'form-control', customClass2, Styles.inputField, isCallCenter && Styles.autofocusInput, isCallCenter && Styles.no_pointer)}
        placeholder={placeholderName ? placeholderName : LABEL().ITEM_SEARCH}
        onChange={(e) => { onChange(e.target.value); isCallCenter && handleInputChange(e.target.value)}}
        aria-label="Search"
        aria-labelledby="searchbtn"
        onClick={() => setIsSearch(true)}
        title="search"
        value={getInputValue('search')}
        onFocus={() => { setKeyboardType('textDefaultCaps'); !isCallCenter && handleBlur(); setInputName('search'); }}
        style={{background: serverAppTheme?.inputBg, borderBottom:serverAppTheme?.inputBorder_Bottom, color:serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder}}
        autoFocus={isCallCenter}
      />
     
      <TouchableDiv
        role="presentation"
        className={cn('position-absolute fs-16', { 'd-none': (searchString?.length === 0) })}
        style={{
          right: '2%',
          top: '50%',
          transform: 'translateY(-50%)'
        }}
        onClick={(e) => { e.preventDefault(); setIsSearch(false); setEmpty('search'); setSearchString(''); onChange(''); }}
      >
        <Cross height={25} width={25} fill={serverAppTheme?.iconcolor} />
      </TouchableDiv>
      <div className={cn('d-flex flex-column  justify-content-end align-items-end border-0', !isSearch ? 'd-none' : '', Styles.myTheme1)}>
        {isSearch && !isCallCenter && (
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={(e) => onClickBtn(e)}
              type={keyboardType}
              maxLength={maxLength}
              typed={typed[inputName] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="btn35"
              spacebtn={Styles.spacebtn}
              customClass={`fs-30 p-2 ${Styles.keyboredBackground}`}
            />
        )}
      </div>
    </div>
  );
};

// Redux Part
const mapStateToProps = ({ oauth }) => ({
  deviceInfo: oauth.deviceInformation,
});

export default connect(mapStateToProps)(Search);
